import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DsBreadcrumbModule } from '@bmw-ds/components';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { buildBreadcrumbTrail } from './breadcrumbs.builder';

@Component({
  selector: 'tqc-breadcrumbs',
  standalone: true,
  imports: [DsBreadcrumbModule, TranslatePipe, RouterLink],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  private readonly router = inject(Router);

  protected readonly breadcrumbs = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => buildBreadcrumbTrail(this.router.routerState.snapshot.root))
    ),
    {
      initialValue: buildBreadcrumbTrail(this.router.routerState.snapshot.root),
    }
  );
}
